import axios from 'axios';
import { getApiUrl, parseMgkResponse } from '@/config/api';

const BASE = '/api/AUsuario';

export default {
  async listar(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar`), filtro);
    return response.data;
  },

  async leer(model) {
    const response = await axios.post(getApiUrl(`${BASE}/lectura`), model);
    return response.data;
  },

  async guardar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/guardar`), model);
    return {
      ...parseMgkResponse(response),
      Data: response.data
    };
  },

  async borrar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar`), model);
    return response.data;
  },

  async actualizarPassword(model) {
    const response = await axios.post(getApiUrl(`${BASE}/actualizar-password`), model);
    return response.data;
  },

  async enviarDatosAcceso(model) {
    const response = await axios.post(getApiUrl(`${BASE}/enviar-datos-acceso`), model);
    return response.data;
  },

  async enviarDatosAccesoMultiple(items) {
    const response = await axios.post(getApiUrl(`${BASE}/enviar-datos-acceso-multiple`), items);
    return response.data;
  },

  async actualizarMiPassword(model) {
    const response = await axios.post(getApiUrl(`${BASE}/mi-password`), model);
    return response.data;
  },

  async actualizarMisCredencialesErp(model) {
    const response = await axios.post(getApiUrl(`${BASE}/mis-credenciales-erp`), model);
    return response.data;
  },

  async importarUsuarios(file) {
    const form = new FormData();
    form.append('archivo', file);
    const response = await axios.post(getApiUrl(`${BASE}/importar`), form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  async listarSoporte(filtro = {}) {
    const response = await axios.post(getApiUrl('/api/AAcceso/UsuariosSoporte'), filtro);
    return response.data;
  }
};
